var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8867 26.1926V11.7992C11.8867 11.2326 12.0567 10.6801 12.3684 10.2126L16.2359 4.4609C16.8451 3.54006 18.3609 2.8884 19.6501 3.37006C21.0384 3.83756 21.9592 5.3959 21.6617 6.78423L20.9251 11.4167C20.8684 11.8417 20.9817 12.2242 21.2226 12.5217C21.4634 12.7909 21.8176 12.9609 22.2001 12.9609H28.0226C29.1417 12.9609 30.1051 13.4142 30.6717 14.2076C31.2101 14.9726 31.3092 15.9642 30.9551 16.9701L27.47 27.5809C27.0309 29.3376 25.1184 30.7684 23.2201 30.7684H17.6951C16.7459 30.7684 15.4142 30.4426 14.8051 29.8334L12.9917 28.4309C12.2976 27.9067 11.8867 27.0709 11.8867 26.1926Z",
    fill: "#34C759"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.38148 9.03906H5.92232C3.72648 9.03906 2.83398 9.88906 2.83398 11.9857V26.2374C2.83398 28.3341 3.72648 29.1841 5.92232 29.1841H7.38148C9.57732 29.1841 10.4698 28.3341 10.4698 26.2374V11.9857C10.4698 9.88906 9.57732 9.03906 7.38148 9.03906Z",
    fill: "#34C759"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.4dcec865172d087c949fbcd6f7367c01.svg";
export { ForwardRef as ReactComponent };